<template>
  <div>
    <h1>404</h1>
    <p>Sorry, the page you were looking for could not be found.</p>
    <p>Please select an option from the menu or search for what you are looking for</p>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
@import '../../less/elements/color.less';

div{
  text-align: center;
}
h1{
  font-size: 10rem;
  color: @color-border;
}
P {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/errors/404.vue